import request from '@/utils/request'

//getSAResNoList
export function getSAResNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/getSAResNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getListConfirmed(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/getListConfirmed`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa012Head
export function epmsa012Head(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/epmsa012Head`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa012Detail
export function epmsa012Detail(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/epmsa012Detail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//getShipNoList
export function getShipNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/getShipNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010BlockList
export function epmsa010BlockList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/epmsa010BlockList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010MovLoc
export function epmsa010MovLoc(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/epmsa010MovLoc`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010MovLoc
export function epmsa010ResGrp(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/epmsa010ResGrp`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010List2
export function epmsa010List2(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/epmsa010List2`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010Save
export function epmsa010Save(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/epmsa010Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010Add
export function epmsa010Add(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/epmsa010Add`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010Delete
export function epmsa010Delete(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/epmsa010Delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa012xls
export function epmsa012xls(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010/epmsa012xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `Steel Assy Carry-Out.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}